<script setup>
import { computed, inject } from 'vue';
import { styleVars } from './shared.js';
import SiteTrailMap from '../SiteTrailMap.vue';
import { pickNetwork } from '../siteTrailMap.js';

const props = defineProps({
    config: { type: Object, required: true },
    accent: { type: String, default: '' },
    org: { type: Object, default: () => ({}) },
    site_data: { type: Object, default: () => ({}) },
});

// No public network is no map for a visitor, heading included; the
// editor keeps SiteTrailMap's prompt (Mus, 2026-10-11).
const editing = inject('tiqEditorCanvas', false);
const network = computed(() => pickNetwork(props.site_data?.networks, props.config.network_id));
</script>

<template>
    <section v-if="network || editing" :id="config.anchor_id || null" class="th-block th-map th-sec" :style="styleVars(config)">
        <div class="th-wrap">
            <div v-if="config.eyebrow || config.heading" class="th-map__head">
                <p v-if="config.eyebrow" class="th-eyebrow">{{ config.eyebrow }}</p>
                <h2 v-if="config.heading" class="th-h2 th-h2--sm">{{ config.heading }}</h2>
            </div>
            <SiteTrailMap class="th-map__map" :config="config" :org="org" :site_data="site_data" :network="network" />
            <p v-if="config.caption" class="th-small th-map__caption">{{ config.caption }}</p>
        </div>
    </section>
</template>

<style scoped>
.th-map__head { margin-bottom: 16px; }
/* The map takes the template's own lines, radius and paper. */
.th-map__map {
    --stm-ink: var(--block-text, var(--th-ink));
    --stm-muted: var(--th-meta);
    --stm-line: var(--th-line);
    --stm-radius: var(--r);
    --stm-paper: var(--th-line-soft);
    --stm-surface: var(--th-paper);
    --stm-accent: var(--accent);
}
.th-map__caption { margin-top: 12px; color: var(--th-meta); }
</style>
